import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { ResultadoVistoriaController } from "../../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../../Context/Historico";
import IconOrSpinner from "../../../../../../Components/Utils/IconOrSpinner";
import { IAtendimentoExtraDetalhado } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";

export default function BotaoAgendamentoReparoClienteAusente() {
    const { Atendimento, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;

    const {
        execute: ResultadoVistoriaAssistencia,
        loading: ResultadoVistoriaAssistenciaLoading,
    } = useAsyncCallback(ResultadoVistoriaController);

    return (
        <button
            type="button"
            className="btn btn-sm btn-primary m-1"
            disabled={
                ResultadoVistoriaAssistenciaLoading ||
                AtendimentoDetalhado.FL_SINCRONIZADO === false
            }
            onClick={() => {
                if (Atendimento?.ID_CASO) {
                    ResultadoVistoriaAssistencia(
                        Atendimento?.ID_CASO ?? 0,
                        "CLIENTE_AUSENTE"
                    ).then(() => {
                        updateAtendimento();
                        ReloadHistorico();
                    });
                }
            }}
        >
            <IconOrSpinner
                icon={faCalendar}
                loadingSize="sm"
                loading={ResultadoVistoriaAssistenciaLoading}
                className="mr-2"
            />
            Agendamento de Reparo
        </button>
    );
}
